// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3u75D","inputDescription":"styles_inputDescription__1LU9P"};